'use client';

import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useHasMounted } from '~/utils/react/client';

type PortalProps = {
    querySelector?: string;
    children: ReactNode;
};

export default function Portal({ querySelector, children }: PortalProps) {
    // False on the server and during hydration, so the portal only renders where `document` exists.
    const mounted = useHasMounted();

    if (!mounted) return null;

    const root: HTMLElement | null = document.querySelector<any>(querySelector) ?? null;
    if (root === null)
        throw new Error(`Portal root element not found with query "${querySelector}"`);

    return createPortal(children, root);
}
